import { Dashboard } from 'app/area/dashboard/dashboard';
import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { scrollToTop } from 'app/infrastructure/platform/routing';
import * as React from 'react';

import { startupTranslation } from './constants';
import { StartupState } from './types-store';
import { NewCaseBanner } from 'app/area/startup/components/new-case-banner';
import { LinksSection } from 'app/area/links-section/links-section';
import { withRouter } from 'app/components/enhancers/with-router';
import { Case } from 'app/area/case';
import { CaseViewModal } from 'app/area/case/components/case-view-modal';
import { Outlet, useOutletContext } from 'node_modules/react-router-dom';

interface StartupComponentProps {
  params: { caseId?: string };
}

const CaseWithRouter = withRouter(Case);
type StartupProps = StartupState & DefaultContainerProps & StartupComponentProps;
const StartupComponent: React.FC<StartupProps> & { statePath?: string } = (props) => {
  React.useEffect(() => {
    scrollToTop();
  }, []);

  const { translation, sharedState, router } = props;  

  return (
    <>
      <div className="container main-grid">
        <NewCaseBanner
          textHeader={translation.new_case_header}
          textDescription={translation.new_case_description}
          textBtnRegisterNewCase={translation.new_case_register}
          textOpenCaseHeader={translation.open_case_header}
          textOpenCaseDescription={translation.open_case_description}
          textCaseNo={translation.open_case_case_no}
          textOpenCase={translation.open_case}
        />
      </div>
      <LinksSection />
      {(!!sharedState.startupDashboardId || !!sharedState.startupDashboardTypeId) && (
        <div id="startup-dashboard">
          <Dashboard
            dashboardType={sharedState.startupDashboardTypeId}
            requestedMainFavouriteId={sharedState.startupDashboardId}
            mainFavouriteReadOnly={true}
            showDescription={false}
            location={router.location}
            hideFilters={true}
          />
          <Outlet context={{ renderCaseViewModal: true }} />
        </div>
      )}
    </>
  );
};

StartupComponent.statePath = STATE.startupArea;

const container = containerFactory(StartupComponent, undefined, null, startupTranslation);
export { container as Startup };

export const StartupCaseViewModal = () => {
  const { renderCaseViewModal } = useOutletContext<{ renderCaseViewModal: boolean }>();
  return (
    renderCaseViewModal && <CaseViewModal>
      <CaseWithRouter />
    </CaseViewModal>
  );
};
